// removed by extract-text-webpack-plugin
module.exports = {"left-column":"app-pages-Reports-Transaction-__Transaction___3OoCg","right-column":"app-pages-Reports-Transaction-__Transaction___30sZ_","report-transaction":"app-pages-Reports-Transaction-__Transaction___2d288","transaction-wrapper":"app-pages-Reports-Transaction-__Transaction___cM255","table-wrapper":"app-pages-Reports-Transaction-__Transaction___1sr2G"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Reports/Transaction/Transaction.css
// module id = 2503
// module chunks = 0